import { type CoreUITheme, chartColors } from '@scality/core-ui/dist/style/theme';
import { useTheme } from 'styled-components';

export const OK_VITALS_THRESHOLD = 80;

export const useVitalCardParams = (history: number[]) => {
  const theme = useTheme() as CoreUITheme;

  const data = history.map((value, index) => [index, value] as [number, number]);
  const startingTimeStamp = 0;
  const sampleDuration = history.length;
  const sampleInterval = 1;
  const lastValue = Math.ceil(history[history.length - 1]);
  const color = lastValue >= OK_VITALS_THRESHOLD ? chartColors.lineColor1 : theme.statusCritical;

  return {
    serie: { data, color },
    startingTimeStamp,
    sampleDuration,
    sampleInterval,
    lastValue,
  };
};
